<template>
  <div>
    <div
      v-for="warning in warnings"
      :key="warning"
    >
      <div
        v-if="warning === warningKeys.WARNING_FLIGHT_DYNAMIC_RYANAIR"
        class="ml-4 mt-4 pt-2"
      >
        <span>
          <span class="mr-1">
            {{ $t('flight.warning.dynamic_ryanair') }}. {{ ' ' }}
          </span>
          <u
            class="cursor-pointer text-nowrap"
            @click="toggleExpandWarning(warning)"
          >{{ isWarningExpanded(warning) ? $t('showLess') : $t('showMoreButton') }}</u>
        </span>
        <div
          v-if="isWarningExpanded(warning)"
          class="mt-4"
        >
          <strong>
            {{ $t('flight.warning.dynamic_ryanair_expanded_title') }}
          </strong>
          <p>
            {{ $t('flight.warning.dynamic_ryanair_expanded') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const warningKeyConstants = {
  WARNING_FLIGHT_DYNAMIC_RYANAIR: 'flight.warning.dynamic_ryanair',
}

export default defineNuxtComponent({
  props: {
    warnings: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    const warningsExpandedObj = Object.values(warningKeyConstants).reduce((obj, warningKey) => ({ ...obj, [warningKey]: false }), {})

    return {
      warningKeys: warningKeyConstants,
      expandedWarnings: warningsExpandedObj,
    }
  },

  methods: {
    toggleExpandWarning (warningKey) {
      this.expandedWarnings[warningKey] = !this.expandedWarnings[warningKey]
    },

    isWarningExpanded (warningKey) {
      return this.expandedWarnings[warningKey]
    },
  },
})
</script>
